<button
  (click)="onButtonClick()"
  [class]="buttonClasses"
  [attr.data-testid]="dataTestId"
  [disabled]="isDisabled"
  [attr.aria-label]="ariaLabel"
>
  <ng-content></ng-content>
</button>
